import { type LocationContent } from "@/components/location-page";
import { FEES, FIRM } from "@/lib/firm";

export const CONTENT: LocationContent = {
  slug: "shelly-beach",
  name: "Shelly Beach",
  title: "Shelly Beach conveyancing, wills and estates",
  metaTitle: `Shelly Beach Conveyancing & Wills Lawyers | ${FIRM.name}`,
  description: `Fixed-fee Shelly Beach conveyancing — sales ${FEES.sale} incl. GST, purchases ${FEES.purchase}. Wills, enduring powers of attorney and deceased estates. Call ${FIRM.phone}.`,
  lead: "Shelly Beach is tightly held: older beach houses on generous blocks, boutique unit blocks along Coochin Street and Onslow Street, and long-term owners whose properties often move through an estate rather than an open listing.",
  paragraphs: [
    "We act for Shelly Beach buyers and sellers from our Golden Beach office, a few minutes away. Because so much of the stock is original and long-held, the contract questions here are usually about the condition of the building, unapproved works and what an older title actually includes.",
    "A large share of Shelly Beach sales are estate sales. Selling as an executor is different from selling as an owner: you need a grant of probate before title can transfer, and the contract should be signed in the correct capacity. We can run the probate application and the sale together.",
    "If you own here and have not looked at your will since the property was bought, it is worth a review — particularly where the family home is the main asset and there are children from more than one relationship.",
  ],
  localNotes: [
    {
      t: "Older homes and unapproved work",
      d: "Enclosed carports, decks and downstairs conversions are common in the original beach houses. We check council records for approvals before you are locked in.",
    },
    {
      t: "Small unit schemes",
      d: "Boutique blocks often have modest sinking funds. The body corporate records tell you about levies, insurance and any special levy on the horizon.",
    },
    {
      t: "Estate sales and probate",
      d: "Executors generally need a grant of probate before the transfer can be registered. We plan the timing so settlement is not delayed waiting on the Supreme Court.",
    },
    {
      t: "Coastal overlays",
      d: "Erosion prone and storm tide overlays apply to parts of the beachfront and affect future rebuild plans. Worth knowing before you buy for the block.",
    },
  ],
  suburbs: ["Moffat Beach", "Kings Beach", "Dicky Beach", "Caloundra", "Battery Hill", "Golden Beach"],
  faqs: [
    {
      q: "Can I sell a Shelly Beach property before probate is granted?",
      a: "You can sign a contract as executor, but the transfer cannot be registered until the grant issues. We usually allow a longer settlement period or make the contract conditional so the sale is not at risk.",
    },
    {
      q: "What does a fixed-fee Shelly Beach conveyance cost?",
      a: `Our professional fee is ${FEES.sale} including GST on a sale and ${FEES.purchase} including GST on a purchase. Searches, transfer duty and registration fees are separate and quoted before you commit.`,
    },
    {
      q: "Should I get a building and pest report on an older beach house?",
      a: "Yes. In this pocket the reports frequently identify termite history, past water ingress and structural changes without approval. The report period is your chance to renegotiate or walk away.",
    },
  ],
};
